<script context="module">
let hasSuffix  = true;
let fnSyllables = [
		"da",
		"vi",
		"je",
		"su",
		"jan",
		"ce",
		"ty",
		"le",
		"mi",
		"ke",
		"ja",
		"son",
		"or",
		"is",
		"ric",
		"sam",
		"tha",
		"be",		
		"pa",
		"ke",
		"ke",
		"che",
		"kla",		
		"pax",		
		"kon",
		"nor",
		"po",
		"pon",
		"kor",
		"kar",
		"zee",
		"ze",
		"xi",
		"ga",
		"ma",
		"ju",
		"ti",
		"ka",
		"luc",
		"xa",
		"wi",		
		"wa",
		"ye",
		"yah",
		"vic",
		"van",
		"vo",
		"qa",
		"co",
		"coo",		
		"ha",
		"hee",		
	];


    let lnNegativePrefix = [
        "malo",
        "mala",
        "darth",
        "bad",
        "max",
        "mega",
		"mara",
		"mar",
		"mort",
		"mors",
		"mori",
		"motis",
		"dead",
		"death"		
        
    ]
    let lnPostivePrefix = [
		"un",
		"un",
		"anti",
		"anti",
		"not",		
		"dis",
		"non",			
		"de",	
		"malo",
        "mala",
        "darth",
        "bad",
		"evil",
		"death",
        "max",
        "mega",
		"mara",
		"mar",
		"mort",
		"mors",
		"mori",
		"motis",	
		"bub",
		"don",
		"ith",
		"than",
		"bus",

	]

	let lnPositives = [
		"good",
		"zen",
		"holy",
		"clean",
		"joy",
		"happy",
		"smile",
		"peace",
		"paz",
		"nice",
		"pleasant",
		"wonder",
		"awe",
		"virtue",
		"neat",
		"great",
		"pleasant",
		"please",
		"health",
		"prime",
		"clear",
		"beaut",
		"grace",
		"charm",
		"glam",
		"fair",
		"love",
		"taste",
		"delight",
		"zeal",
		"fidel",
		"amor",
		"crush",
		"devote",
		"like",
		"friend",
		"pal",
		"brother",
		"sister",
		"father",
		"mother",
		"bud",
		"dad",
		"mom",
		"bueno",
		"buena",
		"bonita",
		"buen",
		"useful",
		"lindo",
		"linda",
		"bella",
		"bien",		
	]


	let lnSyllables = [
		"malo",
		"mala",
		"mal",
		"bad",
		"evil",
		"mord",
		"fear",
		"tear",
		"rip",
		"clash",
		"woe",
		"awful",
		"shod",
		"crap",
		"crook",
		"bum",
		"butt",		
		"trash",
		"pit",
		"grave",
		"grim",
		"woe",
		"mold",
		"rot",
		"rude",
		"crude",
		"ick",
		"filth",
		"dirt",
		"cold",		
		"fake",
		"monger",
		"king",
		"czar",
		"tar",
		"slash",
		"darth",
		"maul",				
		"knife",
		"riot",
		"hein",
		"vile",
		"dire",
		"wet",
		"sog",
		"sin",
		"vice",
		"malign",
		"fiend",
		"ill",
		"curs",
		"cuss",
		"bane",
		"bone",
		"thorn",
		"slash",
		"waste",
		"dreg",
		"dross",
		"scum",
		"vermin",
		"slag",
		"junk",
		"bash",
		"flay",
		"hell",
		"screw",
		"stick",
		"bag",
		"sick",
		"lash",
		"fire",
		"flame",
		"heat",
		"pain",
		"chronic",
		"death",
		"die",
		"murder",
		"kill",
		"douche",
		"peor",
		"stink",
		"gas",
		"odor",
		"rench",
		"beast",
		"dread",
		"conk",		
		"wank",
		"nano",
		"octo",
		"micro",
		"vulgar"

		
	];


	

	


	export	function nameMaker(){
		var randomNumber = (Math.floor(Math.random()*2))
		if(randomNumber){
			// console.log("Name1-"+randomNumber)
			return generateName1();
		}else{
			// console.log("Name2-"+randomNumber)
			return generateName2();
			
		}
	}

	function generateName2() {
		var firstname = "";
		var lastname = "";

		var numberOfSyllablesInFirstName = Math.floor(Math.random() * 3) + 1;
		// var numberOfSyllablesInLastName = Math.floor(Math.random() * 2)+1;
		var numberOfSyllablesInLastName = 1;
		
		for (var i = 0; i < numberOfSyllablesInLastName; i++) {
			// lastname +=
			// 	lnSyllables[Math.floor(Math.random() * lnSyllables.length)];

			lastname +=
			lnPostivePrefix[Math.floor(Math.random() * lnPostivePrefix.length)];
			lastname +=
				lnPositives[Math.floor(Math.random() * lnPositives.length)];	
		}

		for (var i = 0; i < numberOfSyllablesInFirstName; i++) {
			firstname +=
				fnSyllables[Math.floor(Math.random() * fnSyllables.length)];
		}
		return firstname + "-" + lastname
	
	}

 


	function generateName1() {

var firstname = "";
var lastname = "";

var numberOfSyllablesInFirstName = Math.floor(Math.random() * 3) + 1;
// var numberOfSyllablesInLastName = Math.floor(Math.random() * 2) + 1;
var numberOfSyllablesInLastName = 1;

for (var i = 0; i < numberOfSyllablesInLastName; i++) {
	// lastname +=
	// 	lnSyllables[Math.floor(Math.random() * lnSyllables.length)];

	lastname +=
	lnSyllables[Math.floor(Math.random() * lnSyllables.length)];
	lastname +=
		lnSyllables[Math.floor(Math.random() * lnSyllables.length)];	
}

for (var i = 0; i < numberOfSyllablesInFirstName; i++) {
	firstname +=
		fnSyllables[Math.floor(Math.random() * fnSyllables.length)];
}
return firstname + "-" + lastname
}


</script>

{nameMaker()}